export const creditsKeys = {
	all: ['credits'],
	wallet: () => [...creditsKeys.all, 'wallet'],
};
